/* Campaign scope: the two Pluxy Halloween working copies only. */
(() => {
  const ENDS_AT = Date.parse('2026-11-02T04:59:59Z');
  const CODE = 'PLUXYHALLOWEEN26BODY';
  const ROOT = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100);
  const isActive = () => Date.now() <= ENDS_AT;
  async function request(path, body) {
    const response = await fetch(ROOT + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, ...(body ? {body: JSON.stringify(body)} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated. Please try again.');
    return result;
  }
  class HalloweenOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-h26-submit]');
      this.checkbox = this.querySelector('[data-h26-body]');
      this.error = this.querySelector('[data-h26-error]');
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      if (this.checkbox) this.checkbox.disabled = !isActive();
      this.update();
    }
    selection() {
      const body = this.dataset.offer === 'A' && isActive() && this.checkbox?.checked;
      const pair = this.dataset.offer === 'B' && this.form.elements.id.value === '48113297457400';
      return {body, pair, variant: this.form.elements.id.value, total: body ? 6994 : pair ? 7995 : 5995};
    }
    update() {
      if (!isActive() && this.checkbox) {this.checkbox.checked = false; this.checkbox.disabled = true;}
      const {body, pair, total} = this.selection();
      this.querySelector('[data-h26-total]').textContent = money(total);
      this.querySelector('[data-h26-summary]').textContent = body ? 'Face + body · 2 devices' : pair ? 'Gift set · 2 Epil Pros' : '1 Epil Pro';
      this.querySelector('[data-h26-shipping]').textContent = total >= 7500 ? 'USD · Free shipping. Taxes calculated at checkout.' : 'USD · Shipping and taxes calculated at checkout.';
      this.button.textContent = body ? 'Get my face + body set — ' + money(total) : pair ? 'Get my gift set — ' + money(total) : 'Get my Epil Pro — ' + money(total);
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      this.update();
      const chosen = this.selection();
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = 'Adding your offer…';
      this.error.hidden = true;
      const marker = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 9);
      const properties = {_pluxy_h26: this.dataset.offer, _h26_request: marker};
      let before;
      try {
        before = await request('cart.js');
        if (before.currency !== 'USD') throw new Error('This offer is priced in USD. Please choose United States / USD in the store currency selector, then try again.');
        if (chosen.body && before.items.some(item => item.variant_id === 44012623036664)) throw new Error('The Body Epil offer is limited to one per order. Please review the Body Epil already in your cart before adding this set.');
        const items = [{id: chosen.variant, quantity: 1, properties}];
        if (chosen.body) items.push({id: 44012623036664, quantity: 1, properties});
        await request('cart/add.js', {items});
        let cart;
        if (chosen.body) {
          const existing = (before.discount_codes || []).filter(code => code.applicable && code.code.toUpperCase() !== CODE).map(code => code.code);
          cart = await request('cart/update.js', {discount: [...existing, CODE].join(',')});
        } else cart = await request('cart.js');
        const added = cart.items.filter(item => item.properties?._h26_request === marker);
        const face = added.find(item => String(item.variant_id) === chosen.variant);
        const body = added.find(item => item.variant_id === 44012623036664);
        const sum = added.reduce((value, item) => value + item.final_line_price, 0);
        if (!face || (chosen.body && (!body || body.final_price > 999)) || sum > chosen.total) {
          throw new Error('We couldn’t confirm the advertised offer price. Your new items have been removed so you won’t be charged a higher amount. Please try again.');
        }
        window.dataLayer?.push({event: 'pluxy_h26_add_to_cart', offer: this.dataset.offer, body_addon: !!chosen.body, currency: 'USD', value: chosen.total / 100});
        window.location.assign(ROOT + 'cart');
      } catch (error) {
        let message = error.message || 'The cart could not be updated. Please try again.';
        try {
          const current = await request('cart.js');
          const updates = Object.fromEntries(current.items.filter(item => item.properties?._h26_request === marker).map(item => [item.key, 0]));
          if (Object.keys(updates).length) await request('cart/update.js', {updates, ...(chosen.body && before ? {discount: (before.discount_codes || []).filter(code => code.applicable).map(code => code.code).join(',')} : {})});
        } catch (_) {
          message += ' Please review your cart before checkout; we could not confirm that the new items were removed.';
        }
        this.error.textContent = message;
        this.error.hidden = false;
        this.error.focus();
        this.busy = false;
        this.button.disabled = false;
        this.update();
      }
    }
  }
  if (!customElements.get('pluxy-halloween-offer')) customElements.define('pluxy-halloween-offer', HalloweenOffer);
  function refreshExpiry() {
    document.body.classList.toggle('h26-expired', !isActive());
    document.querySelectorAll('pluxy-halloween-offer').forEach(offer => offer.update?.());
  }
  // The site-wide welcome form advertises a conflicting discount. Dismiss only
  // that recognizable Klaviyo promotion; preserve tracking and other dialogs.
  function dismissCompetingOffer() {
    document.querySelectorAll('[role="dialog"].needsclick').forEach(dialog => {
      if (/extra\s+10%\s+off/i.test(dialog.textContent || '')) {
        dialog.querySelector('button[aria-label="Close dialog"]')?.click();
      }
    });
  }
  new MutationObserver(dismissCompetingOffer).observe(document.body, {childList: true, subtree: true});
  dismissCompetingOffer();
  refreshExpiry();
  setInterval(refreshExpiry, 60000);
})();
